module.exports = __webpack_public_path__ + "img/dd-logo-ford-w.29be3fb5.png";